import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalFunction } from '../../../common/core/global_function';
import { ForgotpasswordService } from 'app/common/services/forgotpassword.service';
import { API } from '../../../config/api';

@Component({
    selector: 'app-root',
    templateUrl: 'forgotpassword.component.html',
})

export class ForgotpasswordComponent {
    email_label = "";
    public loading = false;
    constructor(private route: ActivatedRoute,
        private router: Router,
        public forgotpassword_service: ForgotpasswordService) {

    }

    onInit() {
        document.title ='Forgot Password';
    }

    back_link() {
        this.router.navigate(['/authenticate']);
    }

    redirect() {
        let email = this.forgotpassword_service.email;
        this.forgotpassword_service.email = '';
        this.router.navigate(['/authenticate/resetpassword/', email]);
    }
    message_close: any;

    forgotpassword() {
        var that = this;
        if (this.forgotpassword_service.validate()) {
            this.forgotpassword_service.forgot().then(rs => {
                if(rs){
                  console.log(rs);
                  that.message_close.open({
                    'title'     : 'Remind password',
                    'content'   : 'Please check your e-mail and reset password to login to the system.',
                    'closeLabel': 'Close',
                    'confirm'   : function() {
                      that.redirect();
                    }
                  });
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/application/authenticate/forgotpassword/forgotpassword.component.ts